// interface
export interface RootState {
    isSidebarOpen: boolean;
    isLayerselectOpen: boolean;
    success: boolean;
    loader: boolean;
    mapLoaded: boolean;
    questionnaireSteps: Array<Record<string, any>>;
    questionnaireError: null | string;
    mapCircleRadius: number;
    currentQuestionnaireStep: number;
    survey: Survey;
    userData: UserData;
}

export interface Survey {
    layers: Array<Layer>;
    slug: string;
    disableUserInput: boolean;
    disableFileUpload: boolean;
    // geoLoc: string;
    // zoom: number;
}

export interface Layer {
    id: number;
    name: string;
    url: string;
    color: string;
    isSelected: boolean;
}

export interface UserData {
    selectedPlace: SelectedPlace;
    selectedLayers: Array<string | number>;
    userAnswers: Array<Answer>;
    uploadedFiles: Array<any>;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    constent: boolean;
    address: Address;
}

export interface SelectedPlace {
    address: Address;
    location: Record<string, number | null>;
}

export interface Address {
    streetName: string;
    streetNumber: string;
    postalCode: string;
    county: string;
    town: string;
    municipality: string;
}

export interface Answer {
    questionId: number;
    answers?: Array<Record<string, any>>;
    openAnswer?: string;
}

// mutations
export const SET_SIDEBAR_OPEN = 'index/SET_SIDEBAR_OPEN';
export const SET_LAYERSELECT_OPEN = 'index/SET_LAYERSELECT_OPEN';
export const SET_LOADER = 'index/SET_LOADER';
export const SET_MAP_LOADED = 'index/SET_MAP_LOADED';
export const SET_SUCCESS = 'index/SET_SUCCESS';
export const SET_SURVEY_DATA = 'index/SET_SURVEY_DATA';
export const SET_LAYERS = 'index/SET_LAYERS';
export const SET_SELECTED_PLACE = 'index/SET_SELECTED_PLACE';
export const SET_MARKER_RADIUS = 'index/SET_MARKER_RADIUS';
export const SET_IS_LAYER_SELECTED = 'index/SET_IS_LAYER_SELECTED';
export const SET_OPEN_ANSWER = 'index/SET_OPEN_ANSWER';
export const SET_MULTICHOICE_ANSWER = 'index/SET_MULTICHOICE_ANSWER';
export const SET_SINGLECHOICE_ANSWER = 'index/SET_SINGLECHOICE_ANSWER';
export const SET_QUESTIONNAIRE_STEP = 'index/SET_QUESTIONNAIRE_STEP';
export const SET_QUESTIONNAIRE_STEPS = 'index/SET_QUESTIONNAIRE_STEPS';
export const SET_QUESTIONNAIRE_ERROR = 'index/SET_QUESTIONNAIRE_ERROR';
export const REMOVE_FILE = 'index/REMOVE_FILE';
export const ADD_FILE = 'index/ADD_FILE';

// GETTERS
export const GET_ANSWER_BY_ID = 'index/GET_ANSWER_BY_ID';
